import React, { useState, useEffect } from "react";
import axios from "react-axios";
import { Link } from "react-router-dom";
import { useUser } from "~/Context/userContext";
import { useAdditionalGenres } from "~/Context/AdditionalGenresContext";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/free-solid-svg-icons";
import { getTrackGenres, addAdditionalGenreToTrack } from "~/api/getGenre";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const AdditionalFileUnder = ({ trackId, compact = false }) => {
  const { state: userState } = useUser();
  const sharedGenres = useAdditionalGenres();
  const isShared = sharedGenres && sharedGenres.trackId === trackId;

  const [localGenres, setLocalGenres] = useState([]);
  const genres = isShared ? sharedGenres.genres : localGenres;

  const [isLoading, setIsLoading] = useState(false);
  const [genreAdded, setGenreAdded] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [singleSelections, setSingleSelections] = useState([]);

  const loadGenres = async () => {
    const resp = await getTrackGenres(axios, trackId);
    setLocalGenres(resp.data || []);
  };
  useEffect(() => {
    if (!isShared) loadGenres();
  }, [trackId, isShared]);

  useEffect(() => {
    if (show) {
      const inputEl = document.querySelectorAll('[role="combobox"]')[0];
      inputEl.focus()
    }
  }, [show]);

  const addGenre = async () => {
    const genreId = singleSelections[0] && singleSelections[0].id || null;
    const result = await addAdditionalGenreToTrack(axios, genreId, trackId).catch((e) => console.error(e))

    if (result.status == 200) {
      if (result.data.error) {
        console.error(result.data.error);
        setGenreAdded('Track already has genre. Try another.');
      }
      else {
        setGenreAdded('Genre was added! 😎');
        const newGenre = { id: genreId, genre: result.data.genre };
        if (isShared) sharedGenres.addGenre(newGenre);
        else setLocalGenres((prev) => [...prev, newGenre]);
      }

      // clear the input
      setSingleSelections([])
      setTimeout(() => {
        // clear message to user
        setGenreAdded('');
      }, 5000)
    }
  };

  const selectedGenreId = singleSelections[0] && singleSelections[0].id || false;
  const isLoggedinChim = () => userState && userState.loggedin && userState.isChim;
  if (!isLoggedinChim) {
    return null;
  }

  const tagButton = (
    <button type="button" className="tag-track-button" onClick={handleShow} title="Add Tag / File Under for this track">
      <FontAwesomeIcon className="tag-icon" icon={faTag} />
    </button>
  );

  if (compact) {
    return (
      <div className="AdditionalFileUnderWrapper AdditionalFileUnderWrapper--compact">
        {tagButton}
        <Modal centered show={show} onHide={handleClose}>
          <Modal.Header style={{ backgroundColor: '#ccc' }} closeButton>
            <Modal.Title>
              Add File Under
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <div>
              {genres.length > 0 && (
                <div style={{ backgroundColor: '#d0d0d099', padding: '7px 9px', marginBottom: 12, textAlign: 'left' }}>
                  <FontAwesomeIcon className="tag-icon" icon={faTag} style={{ marginRight: 6 }} /> Added: {genres.map((g) => (
                    <Link key={g.id} style={{ paddingRight: 10 }} to={`/genre/${g.id}`}>{g.genre}</Link>
                  ))}
                </div>
              )}
              <p>Add an existing Dream Chimney genre to this track.</p>
              <AsyncTypeahead
                isLoading={isLoading}
                placeholder="Search genres here"
                emptyLabel="No matches. It must be an existing genre."
                onChange={(selected) => {
                  setSingleSelections(selected)
                  // if (selected[0]) {
                  //   setSelectedGenre(selected[0])
                  // }
                }}
                onSearch={(query) => {
                  setIsLoading(true)
                  // @TODO migration back to getGenre
                  fetch(`https://www.dreamchimney.com/api/tracks/genres/find?term=${query}`)
                    .then(resp => resp.json())
                    .then(json => {
                      setSuggestions(json);
                      setIsLoading(false);
                      // this.setState({
                      //   isLoading: false,
                      //   options: json.items,
                      // })
                    });
                }}
                labelKey="name"
                options={suggestions}
                selected={singleSelections}
                style={{ width: 360, marginBottom: 10 }}
              />
              <input type="button" disabled={isLoading || !selectedGenreId} value="Add" onClick={addGenre} />

              {genreAdded !== '' && <span style={{ marginLeft: 10 }}>{genreAdded}</span>}

            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  return (
    <div className="AdditionalFileUnderWrapper">
      <div>
        <div style={{ textAlign: 'left', marginBottom: 24, marginTop: 10 }}>
          {genres.length > 0 && <div style={{ "backgroundColor": "#d0d0d099", "padding": "7px 9px", "marginBottom": "16px", "textAlign": "left" }}>
            <FontAwesomeIcon className="tag-icon" icon={faTag} style={{ marginRight: 6 }} /> Added Genres: {genres.map((g) => <Link key={g.id} style={{ paddingRight: 10 }} title={`Added by ${g.full_name} Chimney`} to={`/genre/${g.id}`}>{g.genre}</Link>)}
          </div>}
          <div>
            {/* <div style={{ marginBottom: 6, textAlign: 'right' }} >
              <Button variant="btn btn-success" onClick={handleShow}>
                <FontAwesomeIcon className="tag-icon" icon={faTag} style={{ marginRight: 6 }} /> Add File Under
              </Button>
            </div> */}
          </div>

          <Modal centered show={show} onHide={handleClose}>
            <Modal.Header style={{ backgroundColor: '#ccc' }} closeButton>
              <Modal.Title>
                Add File Under
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <div>
                <p>Add an existing Dream Chimney genre to this track.</p>
                <AsyncTypeahead
                  isLoading={isLoading}
                  placeholder="Search genres here"
                  emptyLabel="No matches. It must be an existing genre."
                  onChange={(selected) => {
                    setSingleSelections(selected)
                  }}
                  onSearch={(query) => {
                    setIsLoading(true)
                    fetch(`https://www.dreamchimney.com/api/tracks/genres/find?term=${query}`)
                      .then(resp => resp.json())
                      .then(json => {
                        setSuggestions(json);
                        setIsLoading(false);
                      });
                  }}
                  labelKey="name"
                  options={suggestions}
                  selected={singleSelections}
                  style={{ width: 360, marginBottom: 10 }}
                />
                <input type="button" disabled={isLoading || !selectedGenreId} value="Add" onClick={addGenre} />

                {genreAdded !== '' && <span style={{ marginLeft: 10 }}>{genreAdded}</span>}

              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default AdditionalFileUnder;
